import { useState, useEffect } from 'react';
import Query from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';

const useWithOnboardingSteps = ({ setKey, query = Query }) => {
  const [onboardingSteps, setOnboardingSteps] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getOnboardingSteps = async () => {
      try {
        const result = await query(`
        {
          onboarding_steps (set_key: "${setKey ? setKey : ''}") {
            results {
              id
              set_key
              title
              message
              target
              card_config
            }
          }
        }
        `);

        let success = resolve(result, 'data/onboarding_steps/results', []).length;
        if (success) {
          // sort by order field
          let unsorted = resolve(result, 'data/onboarding_steps/results', []);
          let sortedResults = unsorted.sort((stepA, stepB) => (
            resolve(stepA, 'card_config/order', 0) < resolve(stepB, 'card_config/order', 0)
              ? -1 : 1
          ));
          setOnboardingSteps(sortedResults);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.error(e);
      }
    };

    getOnboardingSteps();

  }, [setKey]);

  return {
    loading,
    onboardingSteps
  };
};

export default useWithOnboardingSteps;
